const fields: Record<string, string> = {
  creditCardExpirationMonth: 'Month',
  creditCardExpirationYear: 'Year',
  creditCardType: 'Card Type',
  creditCardNumber: 'Card Number',
  cardSecurityCode: 'CVC',
  creditCardHolderName: 'Name',
  creditCardCountry: 'Country',
  creditCardCity: 'City/Town',
  creditCardPostalCode: 'Code',
} as const;

// for error codes see:
// https://knowledgecenter.zuora.com/Billing/Billing_and_Payments/LA_Hosted_Payment_Pages/B_Payment_Pages_2.0/N_Error_Handling_for_Payment_Pages_2.0/Customize_Error_Messages_for_Payment_Pages_2.0
// and https://knowledgecenter.zuora.com/Billing/Billing_and_Payments/LA_Hosted_Payment_Pages/B_Payment_Pages_2.0/K_Payment_Pages_2.0_Form_Fields
export const handleErrorsWithMessageBus =
  (sendErrorMessageToHpm: (key: string, errorMessage: string) => void) =>
  (key: string, code: string, message: string): void => {
    const codeText: Record<string, (field: keyof typeof fields) => string | null> = {
      '001': (field) => (fields[field] ? `${fields[field]} is required` : null),
      '002': (field) => (fields[field] ? `${fields[field]} is invalid` : null),
      '003': (field) => (fields[field] ? `${fields[field]} is invalid` : null),
      '004': (field) => (fields[field] ? `${fields[field]} is invalid` : null),
      unknown: () => null,
    };

    let errorMessage = message;

    // client error
    if (key !== 'error') {
      errorMessage = codeText[code](key) ?? message;
    }

    // server error
    if (key === 'error') {
      // 3DS2 error message
      if (message.includes('[ThreeDs2_Authentication_Exception]')) {
        errorMessage =
          'Payment failed: 3-D Secure authentication is required to process your payment. If you are unable to do this, please use a different payment method.';
      }
    }

    sendErrorMessageToHpm(key, errorMessage);
  };
